import axios from '../utils/axios';

export default function fetchIntegrations(adminId, params) {
    return axios.get(`/admin/${adminId}/ats-integrations`, { params })
}
